"use client";

import { PageTitle } from "@repo/components";
import { useResetPassword } from "@repo/lib/hooks/account";
import { Button, ErrorMessage, InputPassword, LoadingDots } from "@repo/ui";
import { useTranslations } from "next-intl";
const ResetPassword = ({
  title,
  token,
  email
}) => {
  const {
    formValues,
    formErrors,
    handleValidation,
    isPending,
    showPassword,
    showConfirmPassword,
    togglePasswordVisibility,
    toggleConfirmPasswordVisibility,
    handleSubmit
  } = useResetPassword(token, email);
  const tCommon = useTranslations("Common");
  return <form onSubmit={handleSubmit} data-sentry-component="ResetPassword" data-sentry-source-file="ResetPassword.jsx">
      <div className="mb-6 text-center">
        <PageTitle title={title} variant="small" data-sentry-element="PageTitle" data-sentry-source-file="ResetPassword.jsx" />
      </div>
      <div className="relative pb-6">
        <label htmlFor="password" className="text-supportiveGray4 mb-2 text-sm font-medium">
          {tCommon("Password")}
        </label>
        <InputPassword placeholder={tCommon("Min_8_Characters")} name="password" value={formValues?.password} onChange={handleValidation} className="text-base font-medium" data-sentry-element="InputPassword" data-sentry-source-file="ResetPassword.jsx" />
        <ErrorMessage message={formErrors?.password} data-sentry-element="ErrorMessage" data-sentry-source-file="ResetPassword.jsx" />
      </div>
      <div className="relative">
        <label htmlFor="confirm" className="text-supportiveGray4 mb-2 text-sm font-medium">
          {tCommon("New_Password")}
        </label>
        <InputPassword placeholder={tCommon("Min_8_Characters")} name="confirm" value={formValues?.confirm} onChange={handleValidation} className="text-base font-medium" data-sentry-element="InputPassword" data-sentry-source-file="ResetPassword.jsx" />
        <ErrorMessage message={formErrors?.confirm} data-sentry-element="ErrorMessage" data-sentry-source-file="ResetPassword.jsx" />
      </div>
      <Button size="md" type="submit" className="mt-6 w-full" variant="primary" disabled={isPending} data-sentry-element="Button" data-sentry-source-file="ResetPassword.jsx">
        {isPending ? <LoadingDots className="bg-white" /> : tCommon("Update")}
      </Button>
    </form>;
};
export default ResetPassword;